import * as React from "react";
const SvgFiRrFaceBeamHandOverMouth = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-beam-hand-over-mouth_svg__a)">
      <path
        fill="#062147"
        d="M10 11a1 1 0 0 1-1-1c0-1.054-.679-2-1-2s-1 .946-1 2a1 1 0 1 1-2 0c0-1.892 1.232-4 3-4s3 2.108 3 4a1 1 0 0 1-1 1m9-1c0-1.892-1.232-4-3-4s-3 2.108-3 4a1 1 0 1 0 2 0c0-1.054.679-2 1-2s1 .946 1 2a1 1 0 1 0 2 0M4.687 20.277c.401-.38.42-1.013.041-1.414A9.96 9.96 0 0 1 2.001 12C2 6.486 6.486 2 12 2s10 4.486 10 10a9.93 9.93 0 0 1-1.817 5.75 1 1 0 0 0 1.635 1.153 11.92 11.92 0 0 0 2.183-6.902C24 5.383 18.617 0 12 0S0 5.383 0 12c0 3.076 1.162 6.001 3.273 8.236a1.004 1.004 0 0 0 1.414.041m9.284-7.777a.829.829 0 0 1 .585 1.413l-2.961 2.961 1.002 1.002 3.634-3.634a.825.825 0 0 1 1.17 0 .83.83 0 0 1 0 1.171l-3.631 3.631.985.985 1.84-1.84a.824.824 0 0 1 1.17 0 .82.82 0 0 1 .066 1.071c-.003.029-3.426 3.47-3.426 3.47a4.32 4.32 0 0 1-3.064 1.267c-1.43 0-2.858-.701-3.722-2.102-.425-.69-.612-1.505-.612-2.316v-3.58a1 1 0 0 1 2 0v1.119l4.377-4.377a.82.82 0 0 1 .585-.242z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-beam-hand-over-mouth_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceBeamHandOverMouth;
